export function getGoogleTranslateLang() {
  const langMap = {
    no: "norwegian",
    en: "english",
    fr: "french",
    de: "german",
    es: "spanish",
    hi: "hindi",
    // add more if needed
  };

  const match = document.cookie.match(/(?:^|;)\s*googtrans=([^;]+)/);
  if (match) {
    const parts = decodeURIComponent(match[1]).split("/");
    const code = parts[2] || null; // target language code
    return code ? (langMap[code] || code) : null;
  }
  return null;
}